import type { ProductEventDataList } from 'corgi-types';

import { dispatchTrackingEventGA4 } from 'common/tracking/dispatchTrackingEventGA4';
import { getProductClickEventData } from 'common/tracking/productEventData';
import type { ArticleTracking } from 'common/types/Article';

const enum Event {
  MarkerClick = 'image-marker_click',
  InspirationItemClicked = 'inspiration-item_clicked',
  InspirationItemNavigated = 'inspiration-item_navigated',
}

const enum Element {
  Button = 'button',
}

export const dispatchMarkerClickEvent = (productName: string, variant: string, sku: string) => {
  dispatchTrackingEventGA4({
    event: Event.MarkerClick,
    element: Element.Button,
    product_name: productName,
    variant,
    sku,
  });
};

interface InspirationItemEventParams {
  tracking: Partial<ArticleTracking>;
  list: ProductEventDataList;
  position: number;
}

export const dispatchInspirationItemClickedEvent = ({
  tracking,
  list,
  position,
}: InspirationItemEventParams) => {
  dispatchTrackingEventGA4({
    event: Event.InspirationItemClicked,
    items: [getProductClickEventData({ tracking, list, position })],
  });
};

export const dispatchInspirationItemNavigatedEvent = ({
  tracking,
  list,
  position,
}: InspirationItemEventParams) => {
  dispatchTrackingEventGA4({
    event: Event.InspirationItemNavigated,
    items: [getProductClickEventData({ tracking, list, position })],
  });
};
